(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-fulfillbay-brand-extras"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fb-brand-extras')) {
  customElements.define('fb-brand-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (index, focus = false) => {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
          this.panels[i].inert = i !== index;
        });
        if (focus) this.tabs[index].focus();
      };
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index), options);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) select(index);
      }, options);
      this.mediaQuery = matchMedia('(max-width: 760px)');
      const orient = () => this.querySelector('[role="tablist"]').setAttribute('aria-orientation', this.mediaQuery.matches ? 'horizontal' : 'vertical');
      this.mediaQuery.addEventListener('change', orient, options);
      orient();
      if (this.tabs.length) select(0);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
